export { default as B2BRootLayout } from './B2BCustomTheme';
